export interface TableModel {
  Details: string;
  Type: string,
  ApprovalFor: string;
  RequestedBy: string;
  History: string;
  Action: string;
}
export const table_data: TableModel[] = [
  { Details: "Branch Type 1", Type: "Type 1", ApprovalFor: 'Branch Creation', RequestedBy: "User Name : Aditya", History: '1', Action: '1' },
  { Details: "Branch Type 2", Type: "Type 2", ApprovalFor: 'Branch Creation', RequestedBy: "User Name : Aditya", History: '2', Action: '2' },
  { Details: "Branch Type 3", Type: "Type 3", ApprovalFor: 'Branch Creation', RequestedBy: "User Name : Aditya", History: '3', Action: '3' },
  { Details: "Branch Type 4", Type: "Type 4", ApprovalFor: 'Branch Creation', RequestedBy: "User Name : Aditya", History: '4', Action: '4' },
  { Details: "Branch Type 5", Type: "Type 5", ApprovalFor: 'Branch Creation', RequestedBy: "User Name : Aditya", History: '5', Action: '5' },
  { Details: "Branch Type 6", Type: "Type 6", ApprovalFor: 'Branch Creation', RequestedBy: "User Name : Aditya", History: '6', Action: '6' },
  { Details: "Branch Type 7", Type: "Type 7", ApprovalFor: 'Branch Creation', RequestedBy: "User Name : Aditya", History: '7', Action: '7' },
  { Details: "Branch Type 8", Type: "Type 8", ApprovalFor: 'Branch Creation', RequestedBy: "User Name : Aditya", History: '8', Action: '8' },
  { Details: "Branch Type 9", Type: "Type 9", ApprovalFor: 'Branch Creation', RequestedBy: "User Name : Aditya", History: '9', Action: '9' },
  { Details: "Branch Type 10", Type: "Type 10", ApprovalFor: 'Branch Creation', RequestedBy: "User Name : Aditya", History: '10', Action: '10' },
];

export interface TableModelSuspend {
  InstrumentNo: string;
  InstrumentDate: string,
  InstrumentType: string;
  AmountReceived: string;
  Adjust: string;
}
export const table_data_suspend: TableModelSuspend[] = [
  { InstrumentNo: "HDFC001025611", InstrumentDate: "18/10/2019", InstrumentType: 'Cheque', AmountReceived: "1000", Adjust: '1' },
  { InstrumentNo: "HDFC001025612", InstrumentDate: "19/10/2019", InstrumentType: 'Cheque', AmountReceived: "2000", Adjust: '2' },
  { InstrumentNo: "HDFC001025613", InstrumentDate: "20/10/2019", InstrumentType: 'Cheque', AmountReceived: "3000", Adjust: '3' },
  { InstrumentNo: "HDFC001025614", InstrumentDate: "21/10/2019", InstrumentType: 'Cheque', AmountReceived: "4000", Adjust: '4' },
  { InstrumentNo: "HDFC001025615", InstrumentDate: "22/10/2019", InstrumentType: 'Cheque', AmountReceived: "5000", Adjust: '5' },
  { InstrumentNo: "HDFC001025616", InstrumentDate: "23/10/2019", InstrumentType: 'Cheque', AmountReceived: "6000", Adjust: '6' },
  { InstrumentNo: "HDFC001025617", InstrumentDate: "24/10/2019", InstrumentType: 'Cheque', AmountReceived: "7000", Adjust: '7' },
  { InstrumentNo: "HDFC001025618", InstrumentDate: "25/10/2019", InstrumentType: 'Cheque', AmountReceived: "8000", Adjust: '8' },
  { InstrumentNo: "HDFC001025619", InstrumentDate: "26/10/2019", InstrumentType: 'Cheque', AmountReceived: "9000", Adjust: '9' },
  { InstrumentNo: "HDFC001025610", InstrumentDate: "27/10/2019", InstrumentType: 'Cheque', AmountReceived: "10000", Adjust: '10' },
];
